const locales = require('./locales.json');

const language = locales.reduce((ac, a) => ({ ...ac, [a]: a }), {});

const primaryLanguage = 'es';

const i18n = {
    primaryLanguage,
    language,
};

module.exports = {
    i18n,
};
